import React, { useState, useEffect } from "react";
import AuthComponentWrapper from "../authComponentWrapper/AuthComponentWrapper";
import "../style.css";
import Loader from "../../loader/Loader";
import ResetPasswordForm from "./ResetPasswordForm";

function ResetPassword() {
  const [token, setToken] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fullPath = window.location.href;
    const tokenPart = fullPath.split("/resetpassword/")[1];
    if (tokenPart) {
      // Decode the token in case it was URL encoded
      const decodedToken = decodeURIComponent(tokenPart);
      setToken(decodedToken);
    }
  }, []);

  return (
    <AuthComponentWrapper>
      <Loader open={open} />
      <ResetPasswordForm setOpen={setOpen} token={token} />
    </AuthComponentWrapper>
  );
}

export default ResetPassword;
